var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 44,
    viewBox: "0 0 38 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file_copy_24dp_E8EAED_FILL1_wght400_GRAD0_opsz24",
    d: "M84-876a3.852,3.852,0,0,1-2.825-1.175A3.852,3.852,0,0,1,80-880v-28h4v28h22v4Zm8-8a3.852,3.852,0,0,1-2.825-1.175A3.852,3.852,0,0,1,88-888v-28a3.852,3.852,0,0,1,1.175-2.825A3.852,3.852,0,0,1,92-920h14l12,12v20a3.852,3.852,0,0,1-1.175,2.825A3.852,3.852,0,0,1,114-884Zm12-22h10l-10-10Z",
    transform: "translate(-80 920)",
    fill: "#22638d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.ac96240a0471b94b5e6788862870bbf6.svg";
export { ForwardRef as ReactComponent };